export default "__VITE_ASSET__BMOmaCpX__"